<template>
  <div>
    <hrms-staappr   :staappr='detail.staappr'
                    :nowLang="nowLang"
                    :currentDtereq="setDateOutput(currentDtereq)"
                    :currentNumseq="currentNumseq.toString()"
                    :currentCodempid="currentCodempid" />

    <div class="box-func">
      <div class="box-topic border-color-skin">
        <i class="fa fa-envelope margin-r-5 color-skin"></i>
        <label class="color-skin">{{ descCodapp }}</label>
      </div>

      <div class="box-body">
        <div class="clearfix"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-1"></div>
                    <!-- Leave Code -->
                    <div class="col-md-4 col-lg-3">
                        <div class="form-group">
                            <label>{{ labels['HRES62EC2']['30'] }} <span class="red">*</span></label>
                            <hrms-dropdown  v-model="detail.codleave"
                                            :options="arrCodleave[nowLang]"
                                            :disabled="!validateStaappr"
                                            v-validate="'required'"
                                            data-vv-value-path="inputValue"
                                            data-vv-name="codleave"
                                            :has-error="errors.has('codleave')" />
                            <div class="text-error" v-show="errors.has('codleave')">{{errors.first('codleave')}}</div>
                        </div>
                    </div>
                    <!-- Leave Available -->
                    <div class="col-md-8 col-lg-6">
                        <div class="form-group">
                            <label>{{ labels['HRES62EC2']['15'] }} <i class="fa fa-info-circle color-skin cursor-pointer" @click="getEntitlement(false)" data-toggle="modal" data-target="#hres62e-entitlement-popup" v-show="detail.codleave !== ''"></i></label>
                            <div class="input-group">
                                <input  v-model="entitlement.day3"
                                        class="form-control text-center"
                                        disabled />
                                <span class="input-group-addon disabled-icon">
                                  {{ labels['HRES62EC2']['270'] }}
                                </span>

                                <input  v-model="entitlement.hur3"
                                        class="form-control text-center"
                                        disabled />
                                <span class="input-group-addon disabled-icon">
                                    {{ labels['HRES62EC2']['280'] }}
                                </span>

                                <input  v-model="entitlement.min3"
                                        class="form-control text-center"
                                        disabled />
                                <span class="input-group-addon disabled-icon">
                                    {{ labels['HRES62EC2']['290'] }}
                                </span>
                                <div id="entitlement-loader" class="loader" style="display: none;"></div>
                            </div>
                            <entitlement-popup  :labels="labels"
                                                :data="entitlement" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- New Line -->
            <div class="col-lg-1"></div>

            <!-- group left (Type of Leave) -->
            <div class="col-md-4 col-lg-3">
                <div class="row">
                    <!-- Type of Leave -->
                    <div class="col-md-12">
                        <div>
                            <label>{{ labels['HRES62EC2']['250'] }} <span class="red">*</span></label>
                            <div class="row">
                                <div class="form-group">
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="A" v-model="detail.flgleave" :disabled="enableFlagLeave.r1 == 'F' || !validateStaappr">
                                            {{ labels['HRES62EC2']['200'] }}
                                        </label>
                                    </div>
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="M" v-model="detail.flgleave" :disabled="enableFlagLeave.r2 == 'F' || !validateStaappr">
                                            {{ labels['HRES62EC2']['210'] }}
                                        </label>
                                    </div>
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="E" v-model="detail.flgleave" :disabled="enableFlagLeave.r3 == 'F' || !validateStaappr">
                                            {{ labels['HRES62EC2']['220'] }}
                                        </label>
                                    </div>
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="H" v-model="detail.flgleave" :disabled="enableFlagLeave.r4 == 'F' || !validateStaappr">
                                            {{ labels['HRES62EC2']['230'] }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Day of leave -->
                    <div class="col-md-12">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRES62EC2']['180'] }} <span class="red">*</span></label>
                            <hrms-datepicker  v-model="detail.dteleave"
                                              :disabled="!validateStaappr"
                                              v-validate="'required|date_format:DD/MM/YYYY'"
                                              data-vv-value-path="inputDate"
                                              data-vv-name="dteleave"
                                              name="dteleave"
                                              :has-error="errors.has('dteleave')" />
                            <div class="text-error" v-show="errors.has('dteleave')">{{errors.first('dteleave')}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- group center (date) -->
            <div class="col-md-4 col-lg-3">
                <div class="row">
                    <!-- From Date -->
                    <div class="col-md-12">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRES62EC2']['50'] }} <span class="red">*</span></label>
                            <hrms-datepicker  v-model="detail.dtestrt"
                                              v-validate="'required|date_format:DD/MM/YYYY|before:dteend'"
                                              data-vv-value-path="inputDate"
                                              data-vv-name="dtestrt"
                                              name="dtestrt"
                                              :disabled="disabledDtestrt"
                                              :has-error="errors.has('dtestrt')" />
                            <div class="text-error" v-show="errors.has('dtestrt')">{{errors.first('dtestrt')}}</div>
                        </div>
                    </div>

                    <!-- To Date -->
                    <div class="col-md-12">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRES62EC2']['60'] }} <span class="red">*</span></label>
                            <hrms-datepicker  v-model="detail.dteend"
                                              v-validate="'required|date_format:DD/MM/YYYY|after:dtestrt'"
                                              data-vv-value-path="inputDate"
                                              data-vv-name="dteend"
                                              name="dteend"
                                              :disabled="disabledDteend"
                                              :has-error="errors.has('dteend')" />
                            <div class="text-error" v-show="errors.has('dteend')">{{errors.first('dteend')}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- group right (time) -->
            <div class="col-md-4 col-lg-3">
                <div class="row">
                    <!-- From Time -->
                    <div class="col-md-12">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRES62EC2']['70'] }}</label>
                            <hrms-timepicker  v-model="detail.timstrt"
                                              v-validate="'requiredWhenExist:timend|date_format:HH:mm'"
                                              data-vv-value-path="inputTime"
                                              data-vv-name="timstrt"
                                              name="timstrt"
                                              :disabled="disabledTimstrt"
                                              :has-error="errors.has('timstrt')" />
                            <div class="text-error" v-show="errors.has('timstrt')">{{errors.first('timstrt')}}</div>
                        </div>
                    </div>

                    <!-- From Time -->
                    <div class="col-md-12">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRES62EC2']['80'] }}</label>
                            <hrms-timepicker  v-model="detail.timend"
                                              v-validate="'requiredWhenExist:timstrt|date_format:HH:mm'"
                                              data-vv-value-path="inputTime"
                                              data-vv-name="timend"
                                              name="timend"
                                              :disabled="disabledTimend"
                                              :has-error="errors.has('timend')" />
                            <div class="text-error" v-show="errors.has('timend')">{{errors.first('timend')}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- New Line -->
            <div class="col-lg-1"></div>
            <!-- Detail -->
            <div class="col-md-8 col-lg-6">
                <div class="row">
                    <!-- Detail Leave -->
                    <div class="col-md-12">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRES62EC2']['40'] }} <span class="red">*</span></label>
                            <textarea v-validate="'required|max:200'"
                                      maxlength="200"
                                      name="deslereq"
                                      :class="{ 'form-control' : true, 'input-error' : errors.has('deslereq') }"
                                      v-model="detail.deslereq"
                                      :disabled="!validateStaappr">
                            </textarea>
                            <div class="text-error" v-show="errors.has('deslereq')">{{errors.first('deslereq')}}</div>
                            <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div>
                        </div>
                    </div>
                    <!-- Attach File -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES62EC2']['120'] }}</label>
                            <div class="form-group">
                              <hrms-dropzone  :fileNameQuery="detail.filenam1"
                                              :prefixFileName="currentCodempid"
                                              :flgToggle="detailDisp"
                                              :maxFileSizeInMB="10"
                                              :resizeWidth="1024"
                                              ref="hrmsDropzone" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <div class="box-footer">
        <div class="col-xs-8 col-md-6 col-sm-6  clear-padding">
          <button type="button" class="btn bg-dark-gray" @click="triggerToggle()" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
        </div>
        <div class="col-xs-4 col-md-6 col-sm-6 clear-padding" align="right" >
          <button type="button"  class="btn bg-color-skin" v-show="detail.codleave !== ''" @click="leaveCondition()" data-toggle="modal" href="#hres62e-popup">{{ labels['HRES62EC2']['100'] }}</button>
        </div>
      </div>

      <popup  :labels="labels"
              :data="popup" />

    </div>
  </div>
</template>

<script>
import popup from 'components/hres62e/popup'
import entitlementPopup from 'components/hres62e/entitlementPopup'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import moment from 'moment'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres62e-detail',
  data () {
    return {
      disabledDtestrt: false,
      disabledTimstrt: false,
      disabledDteend: false,
      disabledTimend: false,
      flgDeleteFile: true,
      tempFileName: '',
      tempFileName_: '',
      flgSetFlgLeave: true
    }
  },
  created () {
    if (typeof this.arrCodleave[this.nowLang][this.detail.codleave] === 'undefined') {
      this.detail.codleave = ''
    }
  },
  mount () {
    this.erros.clear()
  },
  watch: {
    enableFlagLeave () {
      this.detailFlgleave()
    },
    worktime () {
      this.triggerDetailFlgleaveChanged(this.detail.flgleave)
    },
    'detail.codleave' () {
      this.getEntitlement(true)
      this.$nextTick(() => {
        this.errors.clear()
      })
    },
    'detail.dtestrt' () {
      this.$validator.validate('dteend', this.detail.dteend).catch(e => {})
    },
    'detail.dteend' () {
      this.$validator.validate('dtestrt', this.detail.dtestrt).catch(e => {})
    },
    'detail.timstrt' () {
      this.$validator.validate('timend', this.detail.timend).catch(e => {})
    },
    'detail.timend' () {
      this.$validator.validate('timstrt', this.detail.timstrt).catch(e => {})
    },
    'detail.deslereq' () {
      this.$validator.validate('deslereq', this.detail.deslereq).catch(e => {})
    },
    'detail.flgleave' () {
      this.triggerDetailFlgleaveChanged(this.detail.flgleave)
    },
    'detail.dteleave' (newVal) {
      if (!this.flgQuery) {
        this.detail.dtestrt = newVal
        this.detail.dteend = newVal
        let searchParams = {
          p_dtework: this.detail.dteleave,
          p_codempid_query: this.detail.codempid
        }
        this.receivedHres62eWorktime(searchParams)
        this.receivedHres62eCodleave(searchParams)
        this.getEntitlement(false)
      }
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
        this.setFlgQuery(false)
      })
    }
  },
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'arrCodleave', 'currentDtereq', 'currentNumseq', 'currentCodempid', 'nowLang', 'postHres62eSave', 'indexSelected', 'entitlement', 'enableFlagLeave', 'receivedHres62eEntitlement', 'worktime', 'receivedHres62eWorktime', 'descCodapp', 'searchIndex', 'popup', 'receivedHres62ePopup', 'receivedHres62eIndex', 'receivedHres62eCodleave', 'detailDisp', 'flgQuery', 'setFlgQuery' ],
  computed: {
    validateStaappr () {
      return (this.detail.staappr !== 'A' && this.detail.staappr !== 'Y' && this.detail.staappr !== 'N')
    },
    dtereqDisplay () {
      return assetsUtils.getDateOutput(this.currentDtereq)
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    getEntitlement (flgSetFlgLeave) {
      let searchParams = {
        p_dtereq: this.detail.dtereq,
        p_seqno: this.detail.seqno,
        p_codleave: this.detail.codleave,
        p_dtestrt: this.detail.dtestrt,
        p_dteend: this.detail.dteend,
        p_timstrt: this.detail.timstrt.replace(':', ''),
        p_timend: this.detail.timend.replace(':', ''),
        p_flgleave: this.detail.flgleave
      }
      this.flgSetFlgLeave = flgSetFlgLeave
      this.receivedHres62eEntitlement(searchParams)
    },
    detailFlgleave () {
      if (this.flgSetFlgLeave) {
        // this.detail.flgleave = 'A'
        if (this.enableFlagLeave.r1 === 'T' && (this.detail.flgleave === 'A' || this.detail.flgleave === '')) {
          this.detail.flgleave = 'A'
        } else if (this.enableFlagLeave.r2 === 'T' && (this.detail.flgleave === 'M')) {
          this.detail.flgleave = 'M'
        } else if (this.enableFlagLeave.r3 === 'T' && (this.detail.flgleave === 'E')) {
          this.detail.flgleave = 'E'
        } else if (this.enableFlagLeave.r4 === 'T' && (this.detail.flgleave === 'H')) {
          this.detail.flgleave = 'H'
        } else {
          this.detail.flgleave = 'A'
        }
      }
    },
    triggerDetailFlgleaveChanged (flgleave) {
      if (!this.flgQuery) {
        this.detail.dtestrt = this.detail.dteleave
        this.detail.dteend = this.detail.dteleave
      }
      if (flgleave === 'A') {
        this.disabledDtestrt = true
        this.disabledTimstrt = true
        this.disabledDteend = false
        this.disabledTimend = true
        this.detail.timstrt = '' // don't show  this.worktime.m_timstrt
        this.detail.timend = '' // don't show  this.worktime.e_timend
      } else if (flgleave === 'M') {
        this.disabledDtestrt = true
        this.disabledTimstrt = true
        this.disabledDteend = true
        this.disabledTimend = true
        this.detail.timstrt = this.worktime.m_timstrt
        this.detail.timend = this.worktime.m_timend
      } else if (flgleave === 'E') {
        this.disabledDtestrt = true
        this.disabledTimstrt = true
        this.disabledDteend = true
        this.disabledTimend = true
        this.detail.timstrt = this.worktime.e_timstrt
        this.detail.timend = this.worktime.e_timend
      } else if (flgleave === 'H') {
        this.disabledDtestrt = false
        this.disabledTimstrt = false
        this.disabledDteend = false
        this.disabledTimend = false
        this.detail.timstrt = this.worktime.m_timstrt
        this.detail.timend = this.worktime.e_timend
      }
      if (this.detail.timstrt !== '') {
        if (this.detail.timstrt < this.worktime.m_timstrt) {
          this.detail.dtestrt = moment(moment(this.detail.dteleave, 'DD/MM/YYYY').add(1, 'days')).format('DD/MM/YYYY')
        }
      }
      if (this.detail.timend !== '') {
        if (this.detail.timend < this.worktime.m_timstrt) {
          this.detail.dteend = moment(moment(this.detail.dteleave, 'DD/MM/YYYY').add(1, 'days')).format('DD/MM/YYYY')
        }
      }
      this.$nextTick(() => {
        this.errors.clear()
      })
    },
    leaveCondition () {
      let popupParams = {
        codleave: this.detail.codleave
      }
      window.scrollTo(0, 0)
      this.receivedHres62ePopup(popupParams)
    },
    saveParams () {
      return {
        codempid: this.currentCodempid,
        staappr: this.detail.staappr,
        seqno: '' + this.currentNumseq,
        codleave: this.detail.codleave,
        flgleave: this.detail.flgleave,
        dtereq: this.currentDtereq,
        dteleave: this.detail.dteleave,
        dtestrt: this.detail.dtestrt,
        dteend: this.detail.dteend,
        timstrt: this.detail.timstrt.replace(':', ''),
        timend: this.detail.timend.replace(':', ''),
        deslereq: this.detail.deslereq,
        desc_codleave: this.detail.desc_codleave,
        filenam1: this.detail.filenam1
      }
    },
    callSave () {
      // this.$refs.hrmsDropzone.$emit('$clearFileTemp')
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel')
          },
          function (isConfirm) {
            if (isConfirm) {
              _this.detail.filenam1 = _this.$refs.hrmsDropzone.inputFileName
              _this.postHres62eSave({ saveParams: _this.saveParams(), searchParams: _this.searchIndex })
            }
          })
        }
      })
    },
    triggerToggle () {
      this.toggle('index')
      this.receivedHres62eIndex(this.searchIndex)
    }
  },
  components: {
    popup,
    entitlementPopup
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?9d2352c2